export const COPY_URL = 'data-copy-url'
export const COPY_SUCCESS = 'data-copy-success'

export const FORBID_TAGS = [
  'script',
  'object',
  'embed',
  'applet',
  'base',
  'link',
  'meta',
  'style',
  'title',
  'head',
  'body',
  'html',
]

export const FORBID_ATTR = [
  'onload',
  'onerror',
  'onclick',
  'onmouseover',
  'onmouseout',
]

export const ADD_TAGS = ['iframe']

export const ADD_ATTR = [
  'allowfullscreen',
  'allow',
  'referrerpolicy',
  'title',
  'target',
  COPY_URL,
  COPY_SUCCESS,
]
